var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthJ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 26,
    viewBox: "0 0 65 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 26C50.4493 26 65 16.8567 65 0H0C0 16.8567 14.5507 26 32.5 26Z",
    fill: "#DE9079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3267 18.6622C50.3915 23.4853 41.913 26 32.4998 26C23.0866 26 14.6081 23.4853 8.67285 18.6622C13.4263 13.2627 22.3167 11 32.4998 11C42.6829 11 51.5733 13.2627 56.3267 18.6622Z",
    fill: "#D67A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4219 8C48.5909 8 62 5.18667 62 0L3 0C3 5.18667 17.75 8 33.4219 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthJ);
export default __webpack_public_path__ + "static/media/Mouth J.8a38500d9bcf28a752e4a5b5a6911967.svg";
export { ForwardRef as ReactComponent };